/**
 * Team Single Content — GSAP ScrollTrigger image pin.
 *
 * On desktop (1025px+), pins the right column profile image so it stays
 * visible while the left column content scrolls past it. The pin releases
 * when the bottom of the left content column reaches the bottom of the
 * viewport.
 *
 * On tablet and mobile: no pinning — the image stacks above the content
 * via CSS only (flex-direction: column-reverse).
 *
 * Requires GSAP core + ScrollTrigger (loaded globally in scripts.php).
 */

document.addEventListener("DOMContentLoaded", function () {
  const DESKTOP_MIN = 1025;

  const sections = document.querySelectorAll(".team-single-content");
  if (!sections.length) return;

  // Register ScrollTrigger plugin.
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  let pinInstances = [];

  function initPins() {
    // Kill any existing pins before re-initialising.
    pinInstances.forEach(function (st) {
      st.kill();
    });
    pinInstances = [];

    if (window.innerWidth < DESKTOP_MIN) {
      return;
    }

    sections.forEach(function (section) {
      const imageWrapper = section.querySelector(
        ".js-team-single-pin-target"
      );
      const contentCol = section.querySelector(
        ".team-single-content__content-col"
      );

      if (!imageWrapper || !contentCol) return;

      const st = ScrollTrigger.create({
        trigger: section,
        start: "top top",     // pin starts when section top hits viewport top
        end: "bottom-=100 bottom-=200",
        pin: imageWrapper,
        pinSpacing: false,
        //markers: true,
      });

      pinInstances.push(st);
    });
  }

  initPins();

  // Re-initialise on resize so pins are removed below the desktop breakpoint.
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initPins, 150);
  });
});
